<template>
  <header>
    <div class="d-lg-none">
      <v-app-bar
        v-if="!$vuetify.breakpoint.lgAndUp"
        app
        color="white"
        class="app-bar-divider"
        elevation="0"
      >
        <BaseLogo version="v2" size="small" />
        <v-spacer />
        <v-btn icon @click="onHamburgerClick">
          <v-icon color="#474AF0"> mdi-menu </v-icon>
        </v-btn>
      </v-app-bar>
    </div>
    <keep-alive>
      <BaseDrawer :open="isDrawerOpen" version="v2" @toggle="toggleDrawer" />
    </keep-alive>
  </header>
</template>

<script>
import BaseLogo from "@/components/Base/Logo";
import BaseAvatar from "@/components/Base/Avatar";
import BaseDrawer from "@/components/Base/Drawer";
import store from "@/store";
import { defineComponent, computed, ref } from "vue";

export default defineComponent({
  name: "BaseHeader",
  components: {
    BaseLogo,
    BaseAvatar,
    BaseDrawer,
  },
  setup() {
    const user = computed(() => store.getters["users/user"]);
    const isDrawerOpen = ref(false);
    const toggleDrawer = ref((state) => (isDrawerOpen.value = state));
    const onHamburgerClick = ref(() => toggleDrawer.value(true));

    return {
      isDrawerOpen,
      onHamburgerClick,
      toggleDrawer,
      user,
    };
  },
});
</script>

<style lang="scss" scoped>
.app-bar-divider {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
